<!-- 储值卡扣费流水上报接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "cmd": "reportTicketUseRecord",
                "parkCode": "2KNVSH0M",
                "recordList": [
                    {
                        "amountReceivable": 0,
                        "availableValue": 165,
                        "carCode": "粤K70833",
                        "carOwner": "储值938",
                        "dedutionValue": 0,
                        "discountAmount": 0,
                        "enterTime": "20170929010000",
                        "leaveTime": "20170929084036",
                        "operatorName": "admin",
                        "parkCode": "2KNVSH0M",
                        "parkName": "自动化测试停车场",
                        "parkingCode": "2017092901000049933565",
                        "telphone": "13817627356",
                        "useTime": "20170929084043",
                        "vipName": "储值VIP349"
                    }
                ],
                "reportTime": "20170929084043"
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "智慧停车开放平台主动上报停车场储值卡扣费流水到第三方接入系统",
                urlPattern:this.commonUrls.third+"reportTicketUseRecord",
                precondition: "无",
                fitSystem: "VEMS传统停车场",
                pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
                frequency:"实时触发",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'reportTime', info2: '是', info3: 'String', info4: '上报时间' },
                        { info1: 'recordList', info2: '是', info3: 'JSONArray', info4: '' }
                        ]
                },{
                    titleName: 'recordList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'parkName', info2: '是', info3: 'String', info4: '停车场名称' },
                        { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车记录编号' },
                        { info1: 'carCode', info2: '是', info3: 'String', info4: '车牌号' },
                        { info1: 'enterTime', info2: '是', info3: 'String', info4: '进场时间，yyyyMMddHHmmss' },
                        { info1: 'leaveTime', info2: '是', info3: 'String', info4: '离场时间，yyyyMMddHHmmss' },
                        { info1: 'amountReceivable', info2: '是', info3: 'Decimal', info4: '应收金额' },
                        { info1: 'discountAmount', info2: '是', info3: 'Decimal', info4: '优惠金额' },
                        { info1: 'carOwner', info2: '是', info3: 'String', info4: '车主' },
                        { info1: 'telphone', info2: '是', info3: 'String', info4: '车主手机号' },
                        { info1: 'carport', info2: '是', info3: 'String', info4: '车位号' },
                        { info1: 'vipName', info2: '是', info3: 'String', info4: '卡名称' },
                        { info1: 'ticketNo', info2: '是', info3: 'String', info4: '卡唯一编号' },
                        { info1: 'dedutionValue', info2: '是', info3: 'Decimal', info4: '扣费金额' },
                        { info1: 'availableValue', info2: '是', info3: 'Decimal', info4: '扣后金额' },
                        { info1: 'operatorName', info2: '是', info3: 'String', info4: '收费员名称，自动放行默认System，确认放行是岗亭收费员名称' },
                        { info1: 'useTime', info2: '是', info3: 'String', info4: '扣费时间，yyyyMMddHHmmss' },
                        { info1: 'timePeriodList', info2: '否', info3: 'JSONArray', info4: '卡有效期列表' },
                        { info1: 'lockKey', info2: '是', info3: 'String', info4: '数据唯一标识' },
                        ]
                },{
                    titleName: 'timePeriodList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'startTime', info2: '是', info3: 'String', info4: '起始时间，yyyyMMddHHmmss' },
                        { info1: 'endTime', info2: '是', info3: 'String', info4: '结束时间，yyyyMMddHHmmss' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        ]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/reportTicketUseRecord.vue